export enum ModelCategory {
  COPYRIGHT_FREE = "copyright_free",
  VOCALS = "vocals",
  INSTRUMENTALS = "instrumentals",
  TRENDING = "trending",
  FAVORITES = "favorites",
  MY_VOICES = "my_voices",
}

export type TModelCategory = `${ModelCategory}`;

export type F0Method = "rmvpe" | "pm";

export type TInferenceSettings = {
  shouldIsolateVocals: boolean;
  shouldEnhanceVocals: boolean;
  cleanAudio: boolean;
  cleanStrength: number;
  f0Method: F0Method;
  transpose: number;
  formantFactor: number;
};

export const DEFAULT_INFERENCE_SETTINGS: TInferenceSettings = {
  shouldIsolateVocals: true,
  shouldEnhanceVocals: false,
  cleanAudio: false,
  cleanStrength: 0.5,
  f0Method: "rmvpe",
  transpose: 0,
  formantFactor: 1,
};

export interface OnboardingState {
  currentStepIndex: number;
  isOpen: boolean;
  onboardingComplete: boolean;
}

export interface OnboardingAction {
  type: "NEXT_STEP" | "PREVIOUS_STEP" | "OPEN_ONBOARDING" | "CLOSE_ONBOARDING";
}
